import AiAgentAdminDashboardHero from '@/client/components/admin/ai-agent/dashboard/AiAgentAdminDashboardHero';
import ExpertsEngagementStatsGroup from '../dashboard/AiAgentAdminEngagementStatsGroup';
import ExpertsPreviewList from '../experts/ExpertsPreviewList';
import { Stack } from '@chakra-ui/react';

export default function AiAgentAdminDashboard() {
  return (
    <Stack spacing={12} height="full" padding={10} paddingTop={8} overflowY="auto">
      <AiAgentAdminDashboardHero />

      <ExpertsEngagementStatsGroup />

      <ExpertsPreviewList />
    </Stack>
  );
}
